/**
 * Memoria de la última conversación de una zona (GEN-EKB-022b), por usuario.
 *
 * Solo se guarda el id del chat, en el navegador: la conversación vive en el kernel (R-PT-09).
 * Si el almacenamiento no está disponible (modo privado, cuota, bloqueado) todo falla en silencio
 * y la zona simplemente no retoma: nunca rompe.
 */
const clave = (zona, usuario) => `dk.zona.${zona}.${usuario ?? 'anon'}.chat`

export function leerChatDeZona(zona, usuario) {
  try { return window.localStorage.getItem(clave(zona, usuario)) || null } catch { return null }
}

export function guardarChatDeZona(zona, usuario, chatId) {
  try { window.localStorage.setItem(clave(zona, usuario), chatId) } catch { /* sin almacenamiento: no se retoma */ }
}

export function olvidarChatDeZona(zona, usuario) {
  try { window.localStorage.removeItem(clave(zona, usuario)) } catch { /* idem */ }
}
